import { Button as ButtonMui, Tabs, Tab as TabMui } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 67px);
  overflow-y: auto;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar { 
    display: none; 
  }
  span.r-title {
    color: #595959;
    font-size: 16px;
    font-weight: 700;
  }
  span.r-info-title {
    color: #0072A2 !important;
    font-size: 12px;
    margin-bottom: 20px;
  }
  span.r-info-title a {
    color: #0072A2 !important;
    border: solid 1px #0072A2 !important;
    padding-left: 3px;
    padding-right: 3px;
    border-radius 3px;
    font-weight: 700;
  }
  span.r-sub {
    color: #99ACC2;
    font-size: 16px;
    font-weight: 700;
  }
  .mb15 {
    margin-bottom: 15px;
  }
  .mt15 {
    margin-top: 15px;
  }
  .MuiInputBase-root {
    height: 48px;
    max-width: 402px;
  }
  .h-price {
    color: #99ACC2;
    font-size: 24px;
    font-weight: 700; 
  }
  .h-title {
    color: #595959;
    font-size: 24px;
    font-weight: 700; 
  }
  .h-sub {
    color: #595959;
    font-size: 18px;
  }
  .MuiChip-root {
    background-color: #595959;
    border: none;
    color: #ffffff;
    svg {
      display: none;
    }
  }
  .tooltip {
    width: 30px;
    height: 30px;
    background-color: #ebf0f6;
    border-radius: 15px;
    text-align: center;
    box-sizing: border-box;
    padding-top: 3px;
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 0px;
    color: #0073a3;
    font-weight: bold;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ebf0f6;
  padding: 25px;
  padding-top: 0px;
  padding-bottom: 0px;
  h2 {
    color: #595959;
    font-size: 32px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 25px;
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Col = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: column;
  justify-content: ${({ flexEnd }) => (flexEnd ? 'flex-end' : 'flex-start')};
  text-align: ${({ flexEnd }) => (flexEnd ? 'right' : 'left')};
  padding-right: ${({ paddingRight }) => (paddingRight ? '5px' : '0px')};
  padding-left: ${({ paddingLeft }) => (paddingLeft ? '5px' : '0px')};
`;

export const ColButton = styled.div`
  display: flex;
  flex: 1;
  :first-of-type {
    padding-right: 10px;
  }
  :last-of-type {
    padding-left: 10px;
  }
`;

export const Table = styled.div`
  width: 100%;
  min-height: 20px;
  background-color: #ffffff;
  border: solid 1px #cbd6e2;
  border-radius: 3px;
  margin-bottom: 24px;
`;

export const TRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  :last-of-type {
    border-top: solid 1px #cbd6e2;
  }
`;

export const TCol = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 10px;
  :last-of-type {
    border-left: solid 1px #cbd6e2;
  }
`;
/*
export const Tabs = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
`
*/

export const StyledTabs = styled(Tabs)`
  background-color: transparent !important;
  div.MuiTabs-scroller {
    background-color: transparent !important;
  }
  .MuiSelected {
    color: #0072a2 !important;
    span.MuiTab-wrapper {
      color: #0072a2 !important;
    }
  }
  span.MuiTabs-indicator {
    display: none;
  }
`;

export const Tab = styled(TabMui)`
  color: #48596b !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  background-color: transparent !important;
  ${({ $hasError }) =>
    $hasError &&
    `
    color: #ff4d4f !important;
    svg {
      color: #ff4d4f;
      font-size: 18px;
    }
  `}
  &.Mui-selected {
    background-color: #ffffff !important;
    color: #0072a2 !important;
    border-top: solid 2px #0072a2;
    border-bottom: none;
    span.MuiTab-wrapper {
      color: #0072a2 !important;
    }
    :hover {
      background-color: #ffffff !important;
    }
  }
  span {
    text-transform: none;
  }
`;

export const Button = styled(ButtonMui)`
  flex: 1;
  span {
    text-transform: none !important;
    font-size: 16px;
    font-weight: 700;
  }
`;

export const SummaryRow = styled.div`
  width: 100%;
`;

export const Contributions = styled.p`
  width: 100%;
  ul {
    list-style-type: none;
    padding: 0;
    li {
      font-weight: 700;
      font-size: 16px;
      color: #595959;
    }
  }
`;

export const GrayText = styled.span`
  color: #99acc2 !important;
  float: right;
`;

export const SaveChip = styled.div`
  width: 100%;
  border: solid 1px #0073a3;
  height: 40px;
  border-radius: 4px;
  margin-bottom: 16px;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  span {
    color: #0073a3;
    font-size: 16px;
    font-weight: 400;
  }
  svg {
    float: right;
    color: #0073a3;
  }
`;

export const ErrorChip = styled.div`
  width: 100%;
  border: solid 1px #ff4d4f;
  height: 40px;
  border-radius: 4px;
  margin-bottom: 16px;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  span {
    color: #ff4d4f;
    font-size: 16px;
    font-weight: 400;
  }
  svg {
    float: right;
    color: #ff4d4f;
  }
`;

export const WarningChip = styled.div`
  position: relative;
  width: 100%;
  border: solid 1px #c99412;
  height: 40px;
  border-radius: 4px;
  margin-top: 16px;
  margin-bottom: 16px;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  span {
    color: #c99412;
    font-size: 14px;
    font-weight: 500;
  }
  svg {
    top: 6px;
    position: absolute;
    right: 10px;
    color: #c99412;
  }
`;

export const ErrorSummary = styled.div`
  width: 100%;
  background-color: #fff5f5;
  border: solid 1px #f1b5b5;
  border-radius: 6px;
  margin-bottom: 16px;
  padding: 16px;
`;

export const ErrorSummaryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #d32f2f;
  font-size: 16px;
  font-weight: 700;
  svg {
    color: #d32f2f;
  }
`;

export const ErrorSummaryDescription = styled.p`
  margin: 4px 0 12px;
  color: #595959;
  font-size: 14px;
`;

export const ErrorSummaryGroup = styled.div`
  & + & {
    margin-top: 12px;
  }
  h4 {
    margin: 0 0 6px;
    color: #595959;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
`;

export const ErrorSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  color: #404040;
  font-size: 14px;
  strong {
    font-weight: 600;
  }
  a {
    cursor: pointer;
    font-size: 14px;
    margin-left: 10px;
    white-space: nowrap;
  }
`;
